const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  // DOM is loaded and ready for manipulation here
  const body = document.querySelector('html,body');
  const siteHeader = document.querySelector('.site-header');
  const closeModal = document.getElementById('close--bannerModal');
  const closeBanner = document.getElementById('close--banner');
  const modal = document.querySelector('.modal_banner');
  const modalOverlay = document.querySelector('.modal_bg_overlay');
  const bannerLink = document.querySelector('.bannerLink__no--modal');
  const bannerLinkAttr = document.querySelector('.bannerLink');
  const bannerNotification = document.querySelector(
    '.bannerNotification.is-style-default-ventures, .bannerNotification.is-style-default-oi, .bannerNotification.is-style-default',
  );
  if (closeModal) {
    closeModal.addEventListener('click', () => {
      modal.classList.remove('active');
      modalOverlay.classList.remove('active');
      body.style.overflow = 'auto';
    });
  }

  if (bannerLink) {
    bannerLink.addEventListener('click', e => {
      e.preventDefault();
      modal.classList.add('active');
      modalOverlay.classList.add('active');
      body.style.overflow = 'hidden';
    });
  }
  if (closeBanner) {
    closeBanner.addEventListener('click', e => {
      bannerNotification.classList.add('d-none');
      if (bannerLinkAttr) {
        e.preventDefault();
      }
    });
  }

  if (bannerLink) {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY ?? window.pageYOffset;
      if (scrollPosition > siteHeader.clientHeight) {
        bannerLink.classList.add('scrolled');
      } else if (scrollPosition < siteHeader.clientHeight) {
        bannerLink.classList.remove('scrolled');
      }
    });
  }
});
